export const ABTestValue = {
    Disabled: 'disabled',
    Enabled_DefaultTrue: 'enabledDefaultTrue',
    Enabled_DefaultFalse: 'enabledDefaultFalse',
};
//# sourceMappingURL=types.js.map